import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3 } from "lucide-react";
import { API } from "@/lib/site";

export const TrendingSources = () => {
  const [sources, setSources] = useState([]);

  useEffect(() => {
    axios.get(`${API}/news/sources`).then((r) => setSources(r.data.sources)).catch(() => setSources([]));
  }, []);

  if (!sources.length) return null;
  const max = sources[0].count;
  return (
    <div data-testid="trending-sources" className="rounded-xl border border-slate-800 bg-[#121722] p-5 space-y-4">
      <div>
        <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-sky-400 flex items-center gap-1.5">
          <BarChart3 className="h-3 w-3" /> Trending sources
        </p>
        <h2 className="font-display font-semibold text-slate-100 mt-1">Who's covering the story most</h2>
      </div>
      <ul className="space-y-3">
        {sources.map((s, i) => (
          <li key={s.source} data-testid={`trending-source-${i}`} className="space-y-1">
            <div className="flex justify-between gap-3 text-xs">
              <span className="truncate text-slate-200">{s.source}</span>
              <span className="font-mono text-slate-400" data-testid={`trending-source-count-${i}`}>{s.count}</span>
            </div>
            <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden">
              <div className="h-full rounded-full bg-gradient-to-r from-[#0052FF] to-[#38BDF8] origin-left rise"
                style={{ width: `${(s.count / max) * 100}%`, animationDelay: `${i * 60}ms` }} />
            </div>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-slate-500">Based on articles in our automated feed.</p>
    </div>
  );
};
